<template>
  <Navbar/>
  <Content :id="this.id"/>
</template>

<script>
import Navbar from "@/components/lesson/Navbar";
import Content from "@/components/lesson/Content";

export default {
  components: {Content, Navbar},
  props: ['id'],
}
</script>
